<template>
	<Loader v-if="loading" />
	<div v-else>

		<div class="flexx">
			<div class="flex-basis">

				<div
					class="flex large-margin-bottom">
					<div>
						<div
							class="bold">Discount created on</div>
							<Format
								type="date"
								:time="true"
								:value="data.discount.created_at"
								/>
					</div>
					<div
						class="margin-left">
						<div
							class="bold">Public key</div>
							{{ data.discount.public_key }}
					</div>
				</div>

				<h3>Definition</h3>
				<div class="flex">

					<div class="flex-basis">
						<select v-model="data.discount.type">
							<option value="percentage">Percentage</option>
							<option value="fixed">Fixed amount</option>
							<option value="free_styling">Free styling</option>
						</select>
					</div>

					<div
						v-show="data.discount.type != 'free_styling'"
						class="flex-basis">
						<MaterialNumber
							:label="data.discount.type == 'percentage' ? '% discount' : 'Amount'"
							class="short margin-left"
							v-model="data.discount.value" />
					</div>

					<div
						v-show="data.discount.type != 'free_styling'"
						class="flex-basis">
						<MaterialNumber
							label="Minimum purchase"
							class="short margin-left"
							v-model="data.discount.minimum_purchase" />
					</div>

				</div>

				<div class="margin-top padding-top border-top" v-if="getView == 'default'">

					<h3 class="no-margin">Order types</h3>
					<p class="xs-margin-top">
						Select the order types which are eligible for this discount
					</p>
					<table>
						<thead>
							<tr>
								<th>Order type</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(order_type, i) in data.order_types">
								<td>
									<div v-if="order_type.order_type_id == 1">Styling</div>
									<div v-if="order_type.order_type_id == 2">Webshop</div>
									<div v-if="order_type.order_type_id == 3">Styling fee</div>
									<div v-if="order_type.order_type_id == 4">Exchange</div>
								</td>
								<td>
									<button class="margin-left small" v-on:click="removeOrderType(i)">Remove</button>
								</td>
							</tr>
						</tbody>
					</table>

					<select
						class="margin-top"
						placeholder="Add order type"
						v-model="add_order_type"
						v-on:change="addOrderType">
						<option
							:disabled="!! data.order_types.filter(row => row.order_type_id == 1).length"
							value="1">Styling</option>
						<option
							:disabled="!! data.order_types.filter(row => row.order_type_id == 2).length"
							value="2">Webshop</option>
						<option
							:disabled="!! data.order_types.filter(row => row.order_type_id == 3).length"
							value="3">Styling fee</option>
						<option
							:disabled="!! data.order_types.filter(row => row.order_type_id == 4).length"
							value="4">Exchange</option>
					</select>
				</div>

			</div>

			<!-- Constraints -->
			<div class="padding-top margin-top border-top">
				<h3 class="no-margin">Constraints</h3>
				<p class="xs-margin-top margin-bottom">
					If you want to make this discount reusable, for example
					for birthday gifts, you can use this <strong>dynamic constraint</strong> feature.
					<a
						href="https://app.clickup.com/2409014/v/dc/29ghp-5901/29ghp-53007"
						style="font-weight: 700;"
						target="_blank">Learn more</a>.
				</p>

				<div
					v-for="(constraint, i) in data.constraints">
					<div
						class="flex margin-bottom">
						<div>
							<div class="xs-margin-bottom">Constraint</div>
							<select
								v-model="constraint.adapter">
								<option value="Birthday">Birthday</option>
								<option value="SignUpDate">Sign-up date</option>
							</select>
						</div>
						<div
							v-for="cell in [
								{
									title: 'Avail. before',
									column: 'available_days_before'
								},
								{
									title: 'Avail. after',
									column: 'available_days_after'
								},
								{
									title: 'Reusable after',
									column: 'reusable_after_days'
								}
							]"
							class="margin-left">
							<div class="xs-margin-bottom">{{ cell.title }}</div>
							<input
								type="number"
								style="width: 60px;"
								v-model="constraint[cell.column]"
								:min="0"
								:max="365"
								/>
								<span
									class="xs-margin-left"
									style="font-size: 12px; color: #aaa;">days</span>
						</div>
						<div
							style="align-items: center;"
							class="margin-left flex">
							<button
								class="gray small small-margin-left"
								v-on:click="deleteConstraint(i)">Delete</button>
						</div>
					</div>
				</div>

				<div
					class="margin-top">
					<button
						class="small"
						v-on:click="addConstraint">+ Constraint</button>
				</div>

			</div>

			<!-- Triggers -->
			<div class="padding-top margin-top border-top" v-if="getView == 'default'">

				<h3 class="no-margin">Triggers</h3>
				<p class="xs-margin-top">
					Select the conditions which will trigger this discount to be activated
				</p>

				<div
					v-for="(trigger, t) in data.triggers"
					class="margin-bottom padding-bottom border-bottom">

					<div class="flex margin-top" style="width: 100%;">
						<div class="flex-basis">
							<div class="xs-margin-bottom">
								Locale
							</div>
							<select v-model="trigger.locale_id">
								<option
									v-for="locale in getLocales"
									:value="locale.id">{{ locale.locale }}</option>
							</select>
						</div>
						<div class="flex-basis">
							<div class="xs-margin-bottom">
								Event
							</div>
							<select v-model="trigger.event" style="width: 160px;">
								<option value=""></option>
								<option value="create_order">On next order</option>
								<option value="sign_up">Based on sign-up date</option>
								<option value="resubscribed">Based on re-subscription</option>
								<option value="code">Discount code</option>
							</select>
						</div>
						<div
							v-if="trigger.event == 'create_order'"
							class="flex-basis">
							<MaterialNumber
								class="short"
								v-model="trigger.customer_id"
								label="Customer ID" />
						</div>
					</div>

					<div
						class="flex margin-top"
						style="width: 100%;">
						<div class="flex-basis">
							<MaterialText
								class="short"
								v-model="trigger.starts_at"
								label="Starts at" />
						</div>
						<div class="flex-basis">
							<MaterialText
								class="short"
								v-model="trigger.ends_at"
								label="Ends at" />
						</div>
						<div class="flex-basis">
							<MaterialToggle
								v-model="trigger.is_active"
								label="Active" />
						</div>
					</div>

					<div
						v-if="trigger.event == 'sign_up' || trigger.event == 'resubscribed'"
						class="flex margin-top"
						style="width: 100%;">
						<div class="flex-basis">
							<MaterialText
								class=""
								v-model="trigger.after"
								:label="trigger.event == 'sign_up' ? 'Signed up after' : 'Re-subscribed after'" />
						</div>
						<div class="flex-basis">
							<MaterialText
								class=""
								v-model="trigger.before"
								:label="trigger.event == 'sign_up' ? 'Signed up before' : 'Re-subscribed before'" />
						</div>
					</div>

					<div
						v-if="trigger.event == 'code'"
						class="flex margin-top"
						style="width: 100%;">
						<!-- <div class="flex-basis">
							<MaterialText
								class=""
								v-model="trigger.tracking_code"
								label="Tracking code" />
						</div> -->
						<div class="flex-basis">
							<MaterialText
								class=""
								v-model="trigger.discount_code_pattern"
								label="Discount code pattern" />
						</div>
					</div>

					<div class="margin-top">
						<button v-on:click="removeTrigger(t)">Remove</button>
					</div>

				</div>

				<button v-on:click="addTrigger">+ Trigger</button>

			</div>
		</div>

		<div class="margin-top padding-top border-top">
      <Loader v-if="softLoading" :soft="true" ></Loader>
			<button
				:disabled="saving"
				v-on:click="update(false)">Save</button>
      <button class="margin-left warning"
				:disabled="saving"
        v-show="saveAnyway"
				v-on:click="update(true)">Save anyway</button>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id',
    'view'
  ],
  computed: {
    ...mapGetters([
      'getCurrencies',
      'getLocales'
    ]),
    getView () {
      return this.view ? this.view : 'default'
    }
  },
  watch: {
    id () {
      this.load()
    }
  },
  data: () => ({
    loading: false,
    softLoading: false,
    saving: false,
    saveAnyway: false,
    data: {},
    add_order_type: false
  }),
  methods: {
    removeOrderType (i) {
      Vue.delete(this.data.order_types, i)
    },
    addOrderType () {
      Vue.set(
        this.data.order_types,
        this.data.order_types.length,
        {
          order_type_id: this.add_order_type
        }
      )

      this.add_order_type = false
    },
    removeTrigger (i) {
      Vue.delete(this.data.triggers, i)
    },
    deleteConstraint (i) {
    	Vue.delete(this.data.constraints, i)
    },
    addTrigger () {
      Vue.set(
        this.data.triggers,
        this.data.triggers.length,
        {}
      )
    },
    addConstraint () {
      Vue.set(
        this.data.constraints,
        this.data.constraints.length,
        {
        	adapter: 'Birthday'
        }
      )
    },
    load () {
      Vue.$api.get('/discount/' + this.id, {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.data = data
      })
    },
    update (force = false) {
      if (!force) {
        Vue.$api.patch('/discount/' + this.id, this.data, {
          loader: toggle => {
            this.saving = toggle
            this.softLoading = true
          },
          always: () => this.softLoading = false,
          error: () => {
            this.saving = false
            this.softLoading = false
            this.saveAnyway = true
            alert('Please click "Save Anyway" to save the discount')
          }
        })
      } else {
        Vue.$api.patch('/discount/' + this.id + '?force_update=true', this.data, {
          loader: toggle => {
            this.saving = toggle
            this.softLoading = true
          },
          always: () => {
            this.softLoading = false
            this.saveAnyway = false
          },
          error: () => {
            this.saving = false
            this.saveAnyway = false
          }
        })
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
